// This file was generated by "make codegen/iam". DO NOT EDIT.
// source: <server_repo_dir>/nexus/agents/agents.actions.go

import { type ReactNode } from "react";
import { type Scope } from "~/hooks/useScope";
import { useCanSetServiceAccountMembership } from "./hook";

export type CanSetServiceAccountMembershipProps = {
  children?: ReactNode;
  fallback?: ReactNode;
  scope?: Scope;
};

export function CanSetServiceAccountMembership({
  children,
  fallback,
  scope,
}: CanSetServiceAccountMembershipProps) {
  const canDoAction = useCanSetServiceAccountMembership(scope);
  return <>{canDoAction ? children : fallback}</>;
}
